export interface IContacts {
  title: string,
  data: string
}

export interface IExpert {
  name: string,
  spec: string,
  contacts: IContacts[],
  text: string | null,
  img: string
}

export const EXPERT: IExpert[] = [
  {
    name: "Марина Долдина",
    spec: "Учредитель, сертифицированный эксперт",
    contacts: [],
    text: "Госзакупки с любовью – такой формат отношения к работе приводит нас к исполнению поставленной миссии компании «Закупки с нами просто»!",
    img: "/images/employees/employee_18.jpg"
  },
  {
    name: "Константин Цилибин",
    spec: "Руководитель направления «Проектно-сметная деятельность. Строительный контроль»",
    contacts: [],
    text: "Знание строительных норм неразрывно связано с возможностями их реализации в строгих рамках закупочного законодательства. " +
      "Провести текущие и капитальные ремонты без нарушений Закона о контрактной системе - тонкое искусство",
    img: "/images/employees/employee_22.jpg"
  },
  {
    name: "Констанция Шишлевская",
    spec: "Директор, сертифицированный эксперт",
    contacts: [],
    text: "Сильная команда видит перспективы там, где другие видят препятствия. " +
      "Мышление на опережение и готовность к развитию — вот, что делает нашу команду непобедимой в решении даже самых сложных задач",
    img: "/images/employees/employee_19.jpg"
  },
  {
    name: "Надежда Чиркова",
    spec: "Директор специализированного структурного образовательного подразделения Учебный центр АБВЗАКУПКИ",
    contacts: [],
    text: "АБВЗАКУПКИ для меня – это мощный вызов в первую очередь самой себе, ценный опыт, " +
      "возможность ежедневно совершенствовать свои навыки, а самое главное – находить новые возможности",
    img: "/images/employees/employee_7.jpg"
  },
  {
    name: "Алла Медведева",
    spec: "Руководитель отдела информационного обеспечения закупок, сертифицированный эксперт",
    contacts: [],
    text: "Если все будут двигаться вперед вместе - успех придет сам собой!",
    img: "/images/employees/employee_9.jpg"
  },
  {
    name: "Ксения Целикова",
    spec: "Руководитель сектора размещения исполнения отдела информационного обеспечения закупок",
    contacts: [],
    text: "Определяющие факторы работы в компании являются её живая и здоровая корпоративная культура, " +
      "внимание к деталям, что в итоге определяет успешную реализацию любой бизнес-стратегии",
    img: "/images/employees/employee_20.jpg" // Нет фото
  },
  {
    name: "Никита Уткин",
    spec: "Руководитель юридического отдела, сертифицированный эксперт",
    contacts: [],
    text: "Госзакупки — это интересно, многообразно и перспективно",
    img: "/images/employees/employee_12.jpg"
  },
  {
    name: "Ольга Чекишева",
    spec: "Руководитель экономического отдела",
    contacts: [],
    text: "Финансы - это маленькая жизнь!",
    img: "/images/employees/employee_17.jpg"
  },
  {
    name: "Татьяна Чижовкина",
    spec: "Ведущий эксперт сектора 223-ФЗ отдела информационного обеспечения закупок, специалист по закупкам, сертифицированный эксперт",
    contacts: [],
    text: "Мы создали команду, в которой каждый вносит свой вклад в общий успех, и вместе мы становимся сильнее " +
      "и эффективнее. Профессионализм наших сотрудников АБВЗАКУПКИ всегда на шаг впереди!",
    img: "/images/employees/employee_14.jpg"
  },
  {
    name: "Ольга Черных",
    spec: "Специалист по закупкам, сертифицированный эксперт",
    contacts: [],
    text: "Работа в компании для меня - это развитие, активность, преодоления и победы. Это свежие мысли и яркие " +
      "идеи. Это часть моей жизни! Уважаю эффективное планирование. Люблю порядок в цифрах. Обожаю целевое расходование",
    img: "/images/employees/employee_13.jpg"
  },
  {
    name: "Константин Карев",
    spec: "Специалист по закупкам, сертифицированный эксперт",
    contacts: [],
    text: "Закупки - искусство управления ресурсами для достижения целей компании. Принципы успешных закупок: " +
      "взвешенные решения, профессионализм и постоянное развитие. Помогают оптимизировать затраты и " +
      "обеспечивать успешное развитие бизнеса",
    img: "/images/employees/employee_5.jpg"
  },
  {
    name: "Анастасия Каменских",
    spec: "Специалист по закупкам, сертифицированный эксперт",
    contacts: [],
    text: "Никто из нас, включая меня, никогда не совершал великих поступков. Но мы все можем делать маленькие вещи с " +
      "большой любовью и вместе сделать что-то замечательное",
    img: "/images/employees/employee_4.jpg"
  },
  {
    name: "Елена Крохалева",
    spec: "Специалист по закупкам",
    contacts: [],
    text: "Будьте открыты для удивительных изменений, которые происходят в области, которая вас интересует",
    img: "/images/employees/employee_20.jpg" // Нет фото
  },
  {
    name: "Ольга Ахмадиева",
    spec: "Специалист по закупкам",
    contacts: [],
    text: "Работаю в АБВЗАКУПКИ с удовольствием! Компания – лидер в своей нише, здесь всегда есть пространство для " +
      "развития и применения экспертизы, особенно в нашей сфере – информационного обеспечения закупок. " +
      "Ценю высокий уровень профессионализма коллег и возможность решать по-настоящему важные задачи",
    img: "/images/employees/employee_10.jpg"
  },
  {
    name: "Ксения Добжанская",
    spec: "Специалист по закупкам",
    contacts: [],
    text: "Нет ничего невозможного! Есть вопрос, на который необходимо найти ответ",
    img: "/images/employees/employee_20.jpg" // Нет фото
  },
  {
    name: "Максим Устьянцев",
    spec: "Специалист по закупкам сектора размещения исполнения отдела информационного обеспечения закупок",
    contacts: [],
    text: "Внимание к деталям в огромной степени определяет успех закупочной деятельности",
    img: "/images/employees/employee_20.jpg" // Нет фото
  },
  {
    name: "Мария Елизарова",
    spec: "Специалист по закупкам сектора размещения исполнения отдела информационного обеспечения закупок",
    contacts: [],
    text: "То, как играет команда в целом, определяет ее успех",
    img: "/images/employees/employee_20.jpg" // Нет фото
  },
  {
    name: "Виолетта Скороходова",
    spec: "Юрист",
    contacts: [],
    text: "Горизонты открываются там, где вместе ломают стены",
    img: "/images/employees/employee_20.jpg" // Нет фото
  },
  {
    name: "Татьяна Балдина",
    spec: "Юрист",
    contacts: [],
    text: "АБВЗАКУПКИ – это грамотное планирование, правильная организация, возможность выбора, многозадачность и " +
      "оптимальное структурирование рабочего времени",
    img: "/images/employees/employee_20.jpg" // Нет фото
  },
  {
    name: "Виктория Головина",
    spec: "Экономист",
    contacts: [],
    text: "Планирование без экономиста - самый запутанный клубок",
    img: "/images/employees/employee_20.jpg" // Нет фото
  },
  {
    name: "Георгий Крохалев",
    spec: "Ведущий эксперт направления «Проектно-сметная деятельность. Строительный контроль»",
    contacts: [],
    text: "Ценю в компании возможность полностью погружаться в цикл строительного проекта: от глубокой проработки смет " +
      "до контроля исполнения. Работа динамичная, задачи комплексные и всегда значимые. Здесь собрана сильная команда " +
      "профессионалов, с которыми строить (в прямом и переносном смысле!) – одно удовольствие",
    img: "/images/employees/employee_23.jpg"
  },
]